import React from "react";
import { useEffect } from "react";
import Lenis from "lenis";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { PathCards } from "../components/site/PathCards";
import { TrustStrip } from "../components/site/TrustStrip";
import { Marquee } from "../components/site/Marquee";
import { Services } from "../components/site/Services";
import { HomeServices } from "../components/site/HomeServices";
import { Manifesto } from "../components/site/Manifesto";
import { About } from "../components/site/About";
import { WhyUs } from "../components/site/WhyUs";
import { ServiceArea } from "../components/site/ServiceArea";
import { BeforeAfter } from "../components/site/BeforeAfter";
import { FAQ } from "../components/site/FAQ";
import { ConnectionForm } from "../components/site/ConnectionForm";
import { Footer } from "../components/site/Footer";

export default function Landing() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <>
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:bg-[#133955] focus:text-white focus:px-5 focus:py-3 focus:rounded-full focus:font-bold">
        Skip to main content
      </a>
      <Header />
      <main id="main-content">
        <Hero />
        <PathCards />
        <TrustStrip />
        <Marquee />
        <Services />
        <HomeServices />
        <Manifesto />
        <WhyUs />
        <About />
        <ServiceArea />
        <BeforeAfter />
        <FAQ />
        <ConnectionForm />
      </main>
      <Footer />
    </>
  );
}
